import React from "react";
import { drawerTabs } from "./HomeData";
import styles from "./Home.module.scss";
import { DrawerComponent } from "../../components/drawer/DrawerComponent";
import { Box } from "@mui/material";
import { Projects } from "../Projects";
import { Profiles } from "../Profiles";
import { Blogs } from "../Blogs";
import { Quotations } from "../Quotations";

export const Home = () => {
  const [activeTab, setActiveTab] = React.useState(drawerTabs[0]);

  const boxContent = React.useMemo(() => {
    switch (activeTab) {
      case drawerTabs[0]:
        return <Projects />;
      case drawerTabs[1]:
        return <Blogs />;
      case drawerTabs[2]:
        return <Profiles />;
      case drawerTabs[3]:
        return <Quotations />;
    }
  }, [activeTab]);

  return (
    <div className={styles.home}>
      <Box component="nav" className={styles.drawerContainer}>
        <DrawerComponent activeTab={activeTab} tabs={drawerTabs} className={styles.drawer} onClick={(selected) => setActiveTab(selected)} />
      </Box>
      <Box className={styles.contentContainer}>
        {boxContent}
      </Box>
    </div>
  );
};
